import React, { useContext } from 'react'
import { SpinnerContext } from '../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { AcceptsTermsAndConditions, getUser } from '../../redux/slices/authSlice'
import { errorToast, successToast } from '../../util/Toast/toast'

const TermsAndCondition = ({ setShowTermsandConditionModal, setIsRefresh }) => {
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()

  const handleTermsAndConditions = async () => {
    setIsRefresh(false)
    changeLoader(true)
    try {
      const { payload } = await dispatch(AcceptsTermsAndConditions())
      setShowTermsandConditionModal(false)
      if (payload?.status === 200) {
        successToast(payload?.data?.status_message || 'Success!!')
        setIsRefresh(true)
        dispatch(getUser())
      } else {
        errorToast(payload?.data?.status_message)
      }
    } catch (error) {
      errorToast('Something went wrong')
    } finally {
      changeLoader(false)
    }
  }

  return (
    <div>
      <div className="text-center mt-3 px-5">
        <div className="mb-5">
          <div className="auth-page-title text-center mb-3">Terms And Conditions</div>
          <p className="auth-page-sub-title text-center">
            {` By booking, you confirm that you've read and agree to our Terms and Conditions, including our policies on cancellations, service limits, and
          liability.`}
          </p>
        </div>
        <button className="btn btn-lg btn-block w-100 btn-primary mb-3" type="submit" onClick={() => handleTermsAndConditions()}>
          I Agree
        </button>
      </div>
    </div>
  )
}

export default TermsAndCondition
